function getBarId(id, groupIndex, seriesIndex) {
  return `${id}-series-${groupIndex}-${seriesIndex}`;
}

export { getBarId };
